"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationControls = void 0;
var react_1 = __importDefault(require("react"));
var react_2 = require("react");
var hocs_1 = require("../hocs");
var hooks_1 = require("../util/hooks");
var Button_1 = __importDefault(require("./Button"));
var grid_1 = require("./grid");
var placeholder = '...';
var arrayFromRange = function (start, end) {
    if (start === void 0) { start = 0; }
    if (end === void 0) { end = 0; }
    return Array(end - start)
        .fill(1)
        .map(function (x, y) { return start + y + 1; });
};
var calculatePages = function (page, totalPages, totalPageButtons) {
    if (totalPageButtons === void 0) { totalPageButtons = 7; }
    // If there are less than 7 pages, show all of them
    if (totalPages <= 7)
        return Array(totalPages)
            .fill(1)
            .map(function (x, y) { return x + y; });
    // If the current page is less than 6, add place holder at the end
    if (page < totalPageButtons - 1)
        return __spreadArray(__spreadArray([], arrayFromRange(0, totalPageButtons - 2), true), [placeholder, totalPages], false);
    // If the current page is close to the end, show last 5 pages with placeholder at the beginning
    if (totalPages - page < 3)
        return __spreadArray([
            1,
            placeholder
        ], arrayFromRange(totalPages - (totalPageButtons - 2), totalPages), true);
    if (totalPageButtons === 5)
        return [1, placeholder, page, placeholder, totalPages];
    // Show placeholder at the beginning and the end
    return [1, placeholder, page - 1, page, page + 1, placeholder, totalPages];
};
exports.PaginationControls = (0, react_2.memo)(function () {
    var _a = (0, hocs_1.usePaginationContext)(), metadata = _a.metadata, prevPage = _a.prevPage, nextPage = _a.nextPage, setPage = _a.setPage, filters = _a.filters;
    var _b = (0, react_2.useState)([]), pages = _b[0], setPages = _b[1];
    var isNarrow = (0, hooks_1.useBreakpoint)('sm');
    (0, react_2.useEffect)(function () {
        var _a;
        setPages(calculatePages((_a = filters.page) !== null && _a !== void 0 ? _a : 1, metadata.total_pages, isNarrow ? 7 : 7));
    }, [metadata.total_pages, filters.page, isNarrow]);
    return (react_1.default.createElement(grid_1.Container, { gap: isNarrow ? 2 : 1.5, direction: isNarrow ? 'column' : 'row' },
        react_1.default.createElement(grid_1.Item, { cols: isNarrow ? 12 : undefined, justify: "space-between", gap: 3 },
            react_1.default.createElement(grid_1.Item, { grow: true, center: true },
                react_1.default.createElement(Button_1.default, { variant: isNarrow ? 'filled' : 'text', onClick: prevPage, disabled: !metadata.has_previous, underline: false, fullWidth: true }, "Prev")),
            react_1.default.createElement(grid_1.Item, { grow: true, hideOver: "sm", center: true },
                react_1.default.createElement(Button_1.default, { variant: isNarrow ? 'filled' : 'text', onClick: nextPage, underline: false, disabled: !metadata.has_more, fullWidth: true }, "Next"))),
        react_1.default.createElement(grid_1.Item, { cols: isNarrow ? 12 : undefined, direction: "row", justify: isNarrow && metadata.total_pages > 5 ? 'space-between' : undefined, gap: 1 }, pages.map(function (page, index) {
            var isPlaceholder = typeof page === 'string';
            return (react_1.default.createElement(grid_1.Item, { key: index, center: true },
                react_1.default.createElement(Button_1.default, { secondary: isPlaceholder ? true : page === filters.page ? false : true, style: { width: 40, height: 40 }, variant: isPlaceholder
                        ? 'text'
                        : page === filters.page
                            ? 'filled'
                            : 'outlined', padded: !isNarrow || !isPlaceholder, onClick: isPlaceholder ? function () { return null; } : function () { return setPage(page); }, underline: false }, page)));
        })),
        react_1.default.createElement(grid_1.Item, { hideUnder: "sm", center: true },
            react_1.default.createElement(Button_1.default, { variant: "text", onClick: nextPage, underline: false, disabled: !metadata.has_more }, "Next"))));
});
//# sourceMappingURL=PaginationControls.js.map